import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputBenutzerRelation<T extends EMode = EMode.entity> {
  /** Alias: userImageFromTempFile */
  userImageFromTempFile?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputBenutzerRelation> = {
  userImageFromTempFile: {
    alias: 'userImageFromTempFile',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputBenutzerRelationEntityDefinition: EntitiyDefinition<InputBenutzerRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputBenutzerRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
